import React, { Component } from 'react';
import { Layout, Row } from 'antd';
import { find, prop, propEq } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import BackButton from 'components/common/elements/BackButton';
import { getProjects, getUser } from 'actions/asyncActions';
import ApplicationForm from './ApplicationForm';
import Breakpoint from 'components/layout/Breakpoint.js';

@withAsyncActions({
    getProjects: getProjects.withOptions({ dispatchOnMount: true }),
    getUser,
})
export default class ProjectApplicationAdd extends Component {
    render() {
        const { project_id } = this.props.match.params;
        const { data: { user } } = this.props.getUser;
        const { data: { projects = [] } } = this.props.getProjects;

        const project = find(propEq('id', Number(project_id)), projects);
        const initialValues = {
            project_id,
            status: 'В работе',
            contact_email: prop('email', user),
            contact_phone: prop('phone_number', user),
            contact_name: prop('name', user),
            contact_surname: prop('surname', user),
            contact_patronymic: prop('patronymic', user),
        };

        return !project || !user ? null : (
            <Layout className="project container page page-sm-no-m main-content">
                <Breakpoint min="sm">
                    <Row type="flex" align="middle" className="m-b-30">
                        <BackButton />
                        <div className="application-title title-route m-l-30">
                            <span>Cоздать заявку</span>
                            <span className="color-link">Проект: {project.name}</span>
                        </div>
                    </Row>
                </Breakpoint>
                <Breakpoint max="sm">
                    <Row className="m-b-30 m-l-20 m-t-10">
                        <BackButton />
                        <div className="application-title title-route m-t-10">
                            <span>Cоздать заявку</span>
                            <span className="color-link">Проект: {project.name}</span>
                        </div>
                    </Row>
                </Breakpoint>
                <ApplicationForm project_id={project_id} initialValues={initialValues} {...this.props} />
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ProjectApplicationAdd.js